export default {
  events: {
    visible: (eWizard, _stepData, params) => {
      // setExtraInformation
      eWizard.querySelector('#titleWelcome')?.setAttribute('label', edicom.locale.translate(params.title || 'enrollment.bmwelcome.bm.title'));

      const eAlert = eWizard.querySelector('#alertWelcome');
      if (eAlert) {
        const welcomeFirstParagraph = edicom.locale.translate(params.firstParagraph || 'enrollment.bmwelcome.bm.firstParagraph');
        const welcomeSecondParagraph = edicom.locale.translate(params.secondParagraph || 'enrollment.bmwelcome.bm.secondParagraph');
        eAlert.lastElementChild.innerHTML = `${welcomeFirstParagraph}<br/><br/>${welcomeSecondParagraph}`;

        if (params.privacyAdvice) {
          eAlert.lastElementChild.insertAdjacentHTML(
            'beforeend',
            ` <br/><br/>
            <div style="text-align:center;">
              <ewc-button ec-normal icon="lock" label="${edicom.locale.translate('enrollment.bmpwelcome.bm.privacyAdvice')}"></ewc-button>
            </div>`
          );

          eAlert.querySelector('ewc-button')?.addEventListener('click', () => {
            window.open(params.privacyAdvice);
          });
        }
      }
    },
  },
  template: `
  <template label="${edicom.locale.translate('enrollment.bmwelcome.title')}">
    <ewc-title id="titleWelcome" level="3"></ewc-title>
    <ewc-alert id="alertWelcome" type="flat">
      <div style="white-space:normal;"></div>
    </ewc-alert>
  </template>`,
};
